import { totemBasicTypes } from "./totemBasicTypes";

// Solicitudes
export const getSolicitudesTotemBasic = (data) => ({
  type: totemBasicTypes.getSolicitudes,
  payload: data,
});

export const deleteSolicitudTotemBasic = (data) => ({
  type: totemBasicTypes.deleteSolicitud,
  payload: data,
});

export const tomarSolicitudTotemBasic = (data) => ({
  type: totemBasicTypes.tomarSolicitud,
  payload: data,
});

export const liberarSolicitudTotemBasic = (data) => ({
  type: totemBasicTypes.liberarSolicitud,
  payload: data,
});

// Boxes
export const getBoxesTotemBasic = (data) => ({
  type: totemBasicTypes.getBoxes,
  payload: data,
});

export const insertBoxTotemBasic = (data) => ({
  type: totemBasicTypes.insertBox,
  payload: data,
});

export const updateBoxTotemBasic = (data) => ({
  type: totemBasicTypes.updateBox,
  payload: data,
});

export const deleteBoxTotemBasic = (data) => ({
  type: totemBasicTypes.deleteBox,
  payload: data,
});

// Boxes Tomados
export const getBoxesTomadosTotemBasic = (data) => ({
  type: totemBasicTypes.getBoxesTomados,
  payload: data,
});

export const tomarBoxTotemBasic = (data) => ({
  type: totemBasicTypes.tomarBox,
  payload: data,
});

export const liberarBoxTotemBasic = (data) => ({
  type: totemBasicTypes.liberarBox,
  payload: data,
});

// Opciones
export const getOpcionesTotemBasic = (data) => ({
  type: totemBasicTypes.getOpciones,
  payload: data,
});

export const insertOpcionTotemBasic = (data) => ({
  type: totemBasicTypes.insertOpcion,
  payload: data,
});

export const updateOpcionTotemBasic = (data) => ({
  type: totemBasicTypes.updateOpcion,
  payload: data,
});

export const deleteOpcionTotemBasic = (data) => ({
  type: totemBasicTypes.deleteOpcion,
  payload: data,
});

// SubOpciones
export const getSubOpcionesTotemBasic = (data) => ({
  type: totemBasicTypes.getSubOpciones,
  payload: data,
});

export const insertSubOpcionTotemBasic = (data) => ({
  type: totemBasicTypes.insertSubOpcion,
  payload: data,
});

export const updateSubOpcionTotemBasic = (data) => ({
  type: totemBasicTypes.updateSubOpcion,
  payload: data,
});

export const deleteSubOpcionTotemBasic = (data) => ({
  type: totemBasicTypes.deleteSubOpcion,
  payload: data,
});

// Opciones Por Box

export const insertOpcionPorBoxTotemBasic = (data) => ({
  type: totemBasicTypes.insertOpcionPorBox,
  payload: data,
});
